<template>
  <modal-structure
    :affirmative-handler="handleAffirmative"
    :btn-ok-text="this.$t('common.save')"
    :show-loading="showLoading"
    :error-message="errorMessage"
    :success-message="successMessage"
    :btn-cancel-text="this.$t('common.cancel')"
    :ok-button-text="this.$t('common.save')"
  >
    <template v-slot:header>
      <h3 class="is-size-3 has-text-centered has-text-weight-bold">
        {{ $t('domains.contacts.'+data.contactType.toLowerCase()) }}
      </h3>
    </template>
    <template v-slot:content>
      <address-form
        :data="contactInfo"
        :disable-form="disableForm"
      />
    </template>
    <template v-slot:footer />
  </modal-structure>
</template>

<script>
import { mapState } from 'vuex'
import ModalStructure from './ModalStructure'
import AddressForm from '@/components/MyDomains/AddressForm'
import domainOverviewMixin from '@/mixins/domain-overview'

export default {

  name: 'ConfirmNavigation',
  components: {
    ModalStructure,
    AddressForm
  },
  mixins: [domainOverviewMixin],
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      contactInfo: Object.assign({}, this.data),
      showLoading: false,
      errorMessage: '',
      successMessage: '',
      disableForm: false
    }
  },
  computed: {
    ...mapState(['services', 'account'])
  },
  methods: {
    async handleAffirmative () {

      if (this.contactInfo.hasError == false ) {
        this.showLoading = true
        this.errorMessage = ''
        this.successMessage = ''
        this.disableForm = true
          
        const result = await this.saveDomainContact(this.services.domainregistration, this.contactInfo)
        if (result) {
          this.successMessage = this.$t('common.info_edited_ok')
          this.disableForm = false
          this.showLoading = false
        } else {
          this.showLoading = false
          this.errorMessage = this.$t('common.info_edited_fail')
          this.disableForm = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .form {
    width: 100%;
    margin-top: auto;
    text-align: left;
  }
</style>
